// import React, { useState, useEffect, useRef } from 'react';
// import { ArrowUpRight, Instagram, Facebook, Twitter, Linkedin, Phone, Mail, MapPin, ChevronUp } from 'lucide-react';

// const PremiumFooter = () => {
//   const [isVisible, setIsVisible] = useState({});
//   const [showScrollTop, setShowScrollTop] = useState(false);
//   const [hoveredSocial, setHoveredSocial] = useState(null);
//   const footerRef = useRef();

//   // Scroll handler for scroll-to-top button
//   useEffect(() => {
//     const handleScroll = () => {
//       setShowScrollTop(window.scrollY > 400);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Intersection Observer for animations
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setIsVisible(prev => ({
//               ...prev,
//               [entry.target.id]: true
//             }));
//           }
//         });
//       },
//       { 
//         threshold: 0.1,
//         rootMargin: '0px 0px -50px 0px'
//       }
//     );

//     const elements = document.querySelectorAll('[data-animate]');
//     elements.forEach((el) => observer.observe(el));

//     return () => observer.disconnect();
//   }, []);

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const socialLinks = [
//     { icon: Instagram, href: "#", label: "Instagram" },
//     { icon: Facebook, href: "#", label: "Facebook" },
//     { icon: Twitter, href: "#", label: "Twitter" },
//     { icon: Linkedin, href: "#", label: "LinkedIn" }
//   ];

//   const quickLinks = [
//     "About Us", "Services", "Portfolio", "Process", "Contact"
//   ];

//   const services = [
//     "Space Planning", "Interior Styling", "Furniture Selection", "Project Management", "Consultation"
//   ];

//   return (
//     <>
//       {/* Load Fonts */}
//       <link
//         href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
//         rel="stylesheet"
//       />

//       <style jsx>{`
//         /* Footer Animations */
//         .fade-up-stagger {
//           opacity: 0;
//           transform: translateY(50px);
//           transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//         }
        
//         .fade-up-stagger.visible {
//           opacity: 1;
//           transform: translateY(0);
//         }
        
//         .fade-left {
//           opacity: 0;
//           transform: translateX(-30px);
//           transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//         }
        
//         .fade-left.visible {
//           opacity: 1;
//           transform: translateX(0);
//         }
        
//         .fade-right {
//           opacity: 0;
//           transform: translateX(30px);
//           transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//         }
        
//         .fade-right.visible {
//           opacity: 1;
//           transform: translateX(0);
//         }

//         /* Social Icon Hover Effects */
//         .social-icon {
//           transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//           position: relative;
//           overflow: hidden;
//         }
        
//         .social-icon::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background: linear-gradient(45deg, #8b7355, #6b5b47);
//           transform: scale(0);
//           transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//           border-radius: inherit;
//           z-index: 0;
//         }
        
//         .social-icon:hover::before {
//           transform: scale(1);
//         }
        
//         .social-icon svg {
//           position: relative;
//           z-index: 1;
//           transition: all 0.3s ease;
//         }
        
//         .social-icon:hover svg {
//           transform: rotate(5deg) scale(1.1);
//           color: white;
//         }

//         /* Link Hover Effects */
//         .footer-link {
//           position: relative;
//           transition: all 0.3s ease;
//           display: inline-block;
//         }
        
//         .footer-link::after {
//           content: '';
//           position: absolute;
//           bottom: -2px;
//           left: 0;
//           width: 0;
//           height: 1px;
//           background: #8b7355;
//           transition: width 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//         }
        
//         .footer-link:hover::after {
//           width: 100%;
//         }
        
//         .footer-link:hover {
//           transform: translateX(5px);
//           color: #8b7355;
//         }

//         /* Newsletter Input Animation */
//         .newsletter-input {
//           transition: all 0.3s ease;
//         }
        
//         .newsletter-input:focus {
//           transform: translateY(-2px);
//           box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
//         }

//         /* Scroll to top button */
//         .scroll-top {
//           transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//           backdrop-filter: blur(10px);
//         }
        
//         .scroll-top:hover {
//           transform: translateY(-3px);
//           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
//         }

//         /* Divider Line Animation */
//         .divider-line {
//           position: relative;
//           overflow: hidden;
//         }
        
//         .divider-line::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: -100%;
//           width: 100%;
//           height: 100%;
//           background: linear-gradient(90deg, transparent 0%, #8b7355 50%, transparent 100%);
//           animation: shimmer 3s ease-in-out infinite;
//         }
        
//         @keyframes shimmer {
//           0% { left: -100%; }
//           50% { left: 100%; }
//           100% { left: 100%; }
//         }

//         /* Logo Hover Effect */
//         .logo-hover {
//           transition: all 0.4s ease;
//         }
        
//         .logo-hover:hover {
//           transform: scale(1.05);
//           filter: brightness(1.1);
//         }
//       `}</style>

//       <footer ref={footerRef} className="bg-[#f5f1eb] border-t border-stone-200/50">
//         {/* Main Footer Content */}
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 lg:py-24">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
            
//             {/* Brand Column */}
//             <div data-animate id="footer-brand" className="lg:col-span-1">
//               <div className={`fade-left ${isVisible['footer-brand'] ? 'visible' : ''}`}>
//                 <div className="logo-hover mb-6">
//                   <h3
//                     className="text-2xl md:text-3xl font-light text-stone-900 tracking-wider"
//                     style={{ fontFamily: "'Playfair Display', serif" }}
//                   >
//                     CONSTRUCT 
//                     <br />
//                     INSIDES
//                   </h3>
//                 </div>
//                 <p className="text-stone-600 mb-8 leading-relaxed text-sm md:text-base">
//                   Creating exceptional interior spaces that reflect your unique style and enhance your lifestyle. Where luxury meets functionality.
//                 </p>
                
//                 {/* Social Links */}
//                 <div className="flex space-x-4">
//                   {socialLinks.map((social, index) => (
//                     <a
//                       key={index}
//                       href={social.href}
//                       aria-label={social.label}
//                       className="social-icon w-10 h-10 md:w-12 md:h-12 border border-stone-300 rounded-full flex items-center justify-center text-stone-600 hover:border-stone-400"
//                       onMouseEnter={() => setHoveredSocial(index)}
//                       onMouseLeave={() => setHoveredSocial(null)}
//                     >
//                       <social.icon className="w-4 h-4 md:w-5 md:h-5" />
//                     </a>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             {/* Quick Links */}
//             <div data-animate id="footer-links" className="lg:col-span-1">
//               <div 
//                 className={`fade-up-stagger ${isVisible['footer-links'] ? 'visible' : ''}`}
//                 style={{ transitionDelay: '200ms' }}
//               >
//                 <h4 
//                   className="text-lg md:text-xl font-light text-stone-900 mb-6 tracking-wider"
//                   style={{ fontFamily: "'Playfair Display', serif" }}
//                 >
//                   QUICK LINKS
//                 </h4>
//                 <ul className="space-y-3">
//                   {quickLinks.map((link, index) => (
//                     <li key={index}>
//                       <a 
//                         href="#" 
//                         className="footer-link text-stone-600 hover:text-stone-900 text-sm md:text-base"
//                       >
//                         {link}
//                       </a>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             </div>

//             {/* Services */}
//             <div data-animate id="footer-services" className="lg:col-span-1">
//               <div 
//                 className={`fade-up-stagger ${isVisible['footer-services'] ? 'visible' : ''}`}
//                 style={{ transitionDelay: '400ms' }}
//               >
//                 <h4 
//                   className="text-lg md:text-xl font-light text-stone-900 mb-6 tracking-wider"
//                   style={{ fontFamily: "'Playfair Display', serif" }}
//                 >
//                   SERVICES
//                 </h4>
//                 <ul className="space-y-3">
//                   {services.map((service, index) => (
//                     <li key={index}>
//                       <a 
//                         href="#" 
//                         className="footer-link text-stone-600 hover:text-stone-900 text-sm md:text-base"
//                       >
//                         {service}
//                       </a>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             </div>

//             {/* Contact & Newsletter */}
//             <div data-animate id="footer-contact" className="lg:col-span-1">
//               <div 
//                 className={`fade-right ${isVisible['footer-contact'] ? 'visible' : ''}`}
//                 style={{ transitionDelay: '600ms' }}
//               >
//                 <h4 
//                   className="text-lg md:text-xl font-light text-stone-900 mb-6 tracking-wider"
//                   style={{ fontFamily: "'Playfair Display', serif" }}
//                 >
//                   GET IN TOUCH
//                 </h4>
                
//                 {/* Contact Info */}
//                 <div className="space-y-4 mb-8">
//                   <div className="flex items-center space-x-3">
//                     <MapPin className="w-4 h-4 text-stone-500 flex-shrink-0" />
//                     <span className="text-stone-600 text-sm md:text-base">
//                       123 Design Street, HYDERABAD
//                     </span>
//                   </div>
//                   <div className="flex items-center space-x-3">
//                     <Phone className="w-4 h-4 text-stone-500 flex-shrink-0" />
//                     <a 
//                       href="tel:+1234567890" 
//                       className="footer-link text-stone-600 text-sm md:text-base"
//                     >
//                       +1 (234) 567-8900
//                     </a>
//                   </div>
//                   <div className="flex items-center space-x-3">
//                     <Mail className="w-4 h-4 text-stone-500 flex-shrink-0" />
//                     <a 
//                       href="mailto:hello@interiorstudio.com" 
//                       className="footer-link text-stone-600 text-sm md:text-base"
//                     >
//                       hello@CONSTRUCTINSIDES.com
//                     </a>
//                   </div>
//                 </div>

//                 {/* Newsletter */}
//                 <div>
//                   <p className="text-stone-600 mb-4 text-sm md:text-base">
//                     Subscribe to our newsletter for design inspiration
//                   </p>
//                   <div className="flex">
//                     <input
//                       type="email"
//                       placeholder="Your email"
//                       className="newsletter-input flex-1 px-4 py-3 bg-white border border-stone-200 focus:border-stone-400 focus:outline-none text-sm md:text-base"
//                     />
//                     <button className="px-6 py-3 bg-stone-800 text-white hover:bg-stone-700 transition-colors duration-300 flex items-center">
//                       <ArrowUpRight className="w-4 h-4" />
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Animated Divider */}
//         <div className="divider-line h-px bg-stone-200 mx-4 sm:mx-6 lg:mx-8"></div>

//         {/* Bottom Bar */}
//         <div data-animate id="footer-bottom">
//           <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 fade-up-stagger ${isVisible['footer-bottom'] ? 'visible' : ''}`}>
//             <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
//               <div className="text-stone-500 text-xs md:text-sm">
//                 © 2025 Construct Insides. All rights reserved.
//               </div>
//               <div className="flex space-x-6 md:space-x-8">
//                 <a href="#" className="footer-link text-stone-500 hover:text-stone-900 text-xs md:text-sm">
//                   Privacy Policy
//                 </a>
//                 <a href="#" className="footer-link text-stone-500 hover:text-stone-900 text-xs md:text-sm">
//                   Terms of Service
//                 </a>
//                 <a href="#" className="footer-link text-stone-500 hover:text-stone-900 text-xs md:text-sm">
//                   Cookies
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Scroll to Top Button */}
//         <button
//           onClick={scrollToTop}
//           className={`scroll-top fixed bottom-8 right-8 w-12 h-12 md:w-14 md:h-14 bg-white/80 border border-stone-200 rounded-full flex items-center justify-center text-stone-600 hover:text-stone-900 z-50 transition-all duration-300 ${
//             showScrollTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
//           }`}
//         >
//           <ChevronUp className="w-5 h-5 md:w-6 md:h-6" />
//         </button>
//       </footer>
//     </>
//   );
// };

// export default PremiumFooter;



import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram, Facebook, Twitter, Linkedin, Phone, Mail, MapPin, ChevronUp } from 'lucide-react';

const PremiumFooter = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Simplified scroll handler
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          setShowScrollTop(window.scrollY > 400);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const socialLinks = [
    { icon: Instagram, href: "https://www.instagram.com/constructinsides?utm_source=ig_web_button_share_sheet&igsh=MXV1bXN3am91dXFuOA==", label: "Instagram" },
    { icon: Facebook, href: "https://www.facebook.com/constructinsides.in", label: "Facebook" },
    // { icon: Twitter, href: "#", label: "Twitter" },
    // { icon: Linkedin, href: "#", label: "LinkedIn" }
  ];

  const quickLinks = [
  { name: 'Home', path: '/' },
  { name: 'Services', path: '/services' },
  { name: 'About Us', path: '/about' },
  { name: 'Contact', path: '/contact' },
];

  return (
    <>
      {/* Load Fonts */}
      <link
        href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
        rel="stylesheet"
      />

      {/* Minimal CSS for performance */}
      <style jsx>{`
        .footer-link {
          transition: color 0.2s ease;
        }
        
        .footer-link:hover {
          color: #8b7355;
        }
        
        .social-icon {
          transition: all 0.2s ease;
        }
        
        .social-icon:hover {
          background-color: #8b7355;
          border-color: #8b7355;
          color: white;
        }
        
        .scroll-top {
          transition: all 0.3s ease;
        }
        
        .scroll-top:hover {
          background-color: #8b7355;
          color: white;
        }
        
        .newsletter-input:focus {
          border-color: #8b7355;
          outline: none;
        }
      `}</style>

      <footer className="bg-[#f5f1eb] border-t border-stone-200/50">
        {/* Main Footer Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
            
            {/* Brand Column */}
            <div className="lg:col-span-1">
              <div className="mb-6">
                <h3
                  className="text-2xl md:text-3xl font-light text-stone-900 tracking-wider"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  CONSTRUCT 
                  <br />
                  INSIDES
                </h3>
              </div>
              <p className="text-stone-600 mb-8 leading-relaxed text-sm md:text-base">
                Creating exceptional interior spaces that reflect your unique style and enhance your lifestyle. Where luxury meets functionality.
              </p>
              
              {/* Social Links */}
              <div className="flex space-x-4">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    aria-label={social.label}
                    className="social-icon w-10 h-10 md:w-12 md:h-12 border border-stone-300 rounded-full flex items-center justify-center text-stone-600"
                  >
                    <social.icon className="w-4 h-4 md:w-5 md:h-5" />
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            {/* <div className="lg:col-span-1">
              <h4 
                className="text-lg md:text-xl font-light text-stone-900 mb-6 tracking-wider"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                QUICK LINKS
              </h4>
              <ul className="space-y-3">
                {["About Us", "Services", "Contact"].map((link, index) => (
                  <li key={index}>
                    <a 
                      href="#" 
                      className="footer-link text-stone-600 text-sm md:text-base"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div> */}
                <div className="lg:col-span-1">
      <h4 
        className="text-lg md:text-xl font-light text-stone-900 mb-6 tracking-wider"
        style={{ fontFamily: "'Playfair Display', serif" }}
      >
        QUICK LINKS
      </h4>
      <ul className="space-y-3">
        {quickLinks.map((link, index) => (
          <li key={index}>
            <Link 
              to={link.path}
              className="footer-link text-stone-600 text-sm md:text-base hover:text-stone-900 transition-colors duration-200"
            >
              {link.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>

            {/* Services */}
            <div className="lg:col-span-1">
              <h4 
                className="text-lg md:text-xl font-light text-stone-900 mb-6 tracking-wider"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                SERVICES
              </h4>
              <ul className="space-y-3">
                {["Modular Kitchens","Modular Wardrobes","Lighting","Flooring","Electrical Work","Civil Work","False Ceiling","Wall Design & Painting"].map((service, index) => (
                  <li key={index}>
                    <a href="#"  className="footer-link text-stone-600 text-sm md:text-base">
                      {service}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact & Newsletter */}
            <div className="lg:col-span-1">
              <h4 
                className="text-lg md:text-xl font-light text-stone-900 mb-6 tracking-wider"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                GET IN TOUCH
              </h4>
              
              {/* Contact Info */}
              <div className="space-y-4 mb-8">
                <div className="flex items-center space-x-3">
                  <MapPin className="w-4 h-4 text-stone-500 flex-shrink-0" />
                  <span className="text-stone-600 text-sm md:text-base">
                    Mathrusree Nagar, Miyapur, HYDERABAD
                  </span>
                </div>
                <div className="flex items-center space-x-3">
                  <Phone className="w-4 h-4 text-stone-500 flex-shrink-0" />
                  <a 
                    href="tel:+1234567890" 
                    className="footer-link text-stone-600 text-sm md:text-base"
                  >
                    +91 95735 78899
                  </a>
                </div>
                <div className="flex items-center space-x-3">
                  <Mail className="w-4 h-4 text-stone-500 flex-shrink-0" />
                  <a 
                    href="mailto:hello@constructinsides.com" 
                    className="footer-link text-stone-600 text-sm md:text-base"
                  >
                    Constructinsides@gmail.com
                  </a>
                </div>
              </div>

              {/* Newsletter */}
              <div>
                <p className="text-stone-600 mb-4 text-sm md:text-base">
                  Subscribe to our newsletter for design inspiration
                </p>
                <div className="flex">
                  <input
                    type="email"
                    placeholder="Your email"
                    className="newsletter-input flex-1 px-4 py-3 bg-white border border-stone-200 text-sm md:text-base"
                  />
                  <button className="px-6 py-3 bg-stone-800 text-white hover:bg-stone-700 transition-colors duration-300 flex items-center">
                    <ArrowUpRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-stone-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="text-stone-500 text-xs md:text-sm">
                © 2025 Construct Insides. All rights reserved.
              </div>
              <div className="flex space-x-6 md:space-x-8">
                <a href="#" className="footer-link text-stone-500 text-xs md:text-sm">
                  Privacy Policy
                </a>
                <a href="#" className="footer-link text-stone-500 text-xs md:text-sm">
                  Terms of Service
                </a>
                <a href="#" className="footer-link text-stone-500 text-xs md:text-sm">
                  Cookies
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll to Top Button */}
        <button
          onClick={scrollToTop}
          className={`scroll-top fixed bottom-8 right-8 w-12 h-12 md:w-14 md:h-14 bg-white border border-stone-200 rounded-full flex items-center justify-center text-stone-600 z-50 ${
            showScrollTop ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <ChevronUp className="w-5 h-5 md:w-6 md:h-6" />
        </button>
      </footer>
    </>
  );
};

export default PremiumFooter;